import { Link } from "react-router-dom";
import { Lock, Mail, Sparkles } from "lucide-react";
import { RESOURCE_TYPES } from "@/lib/cta";
import { mediaUrl } from "@/lib/cmsApi";

const ACCESS_BADGE = {
    open: null,
    email: { icon: Mail, text: "Free with email" },
    report: { icon: Sparkles, text: "Personalized" },
};

const ResourceCard = ({ resource }) => {
    const badge = ACCESS_BADGE[resource.access_type];
    return (
        <Link
            to={`/resources/${resource.slug}`}
            data-testid={`resource-card-${resource.slug}`}
            className="card-surface group flex h-full flex-col overflow-hidden !p-0 transition-colors hover:border-[#3fcbf3]/30"
        >
            <div className="relative aspect-[16/9] overflow-hidden bg-[#0c1322]">
                {resource.cover_image ? (
                    <img src={mediaUrl(resource.cover_image)} alt={resource.title} loading="lazy"
                        className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                ) : (
                    <div className="flex h-full w-full items-center justify-center">
                        <span className="font-display bg-gradient-to-r from-[#45d1f5] to-[#f0356f] bg-clip-text text-4xl text-transparent">
                            SHRED<span className="text-transparent">X</span>pro
                        </span>
                    </div>
                )}
                {badge && (
                    <span className="absolute left-3 top-3 flex items-center gap-1.5 rounded-full bg-black/70 px-3 py-1 text-[10px] font-extrabold uppercase tracking-widest text-[#3fcbf3] backdrop-blur">
                        <badge.icon className="h-3 w-3" /> {badge.text}
                    </span>
                )}
            </div>
            <div className="flex flex-1 flex-col p-5">
                <div className="flex flex-wrap items-center gap-2">
                    <span className="rounded-full border border-[#f0356f]/30 bg-[#f0356f]/10 px-2.5 py-0.5 text-[10px] font-extrabold uppercase tracking-widest text-[#ff6fa5]">
                        {RESOURCE_TYPES[resource.resource_type] || "Resource"}
                    </span>
                    {resource.category_name && (
                        <span className="text-[10px] font-bold uppercase tracking-widest text-[#7d8da3]">
                            {resource.category_name}
                        </span>
                    )}
                </div>
                <h3 className="font-display mt-3 text-xl leading-snug text-white">{resource.title}</h3>
                {resource.excerpt && (
                    <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-[#9fb0c7]">{resource.excerpt}</p>
                )}
                <span className="mt-auto pt-4 text-xs font-extrabold uppercase tracking-[0.2em] text-[#3fcbf3]">
                    Read Free <Lock className="hidden" />
                </span>
            </div>
        </Link>
    );
};

export default ResourceCard;
